/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserByEmailRequest
 */
export interface UserByEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof UserByEmailRequest
     */
    email: string;
}

/**
 * Check if a given object implements the UserByEmailRequest interface.
 */
export function instanceOfUserByEmailRequest(value: object): value is UserByEmailRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function UserByEmailRequestFromJSON(json: any): UserByEmailRequest {
    return UserByEmailRequestFromJSONTyped(json, false);
}

export function UserByEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserByEmailRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function UserByEmailRequestToJSON(json: any): UserByEmailRequest {
    return UserByEmailRequestToJSONTyped(json, false);
}

export function UserByEmailRequestToJSONTyped(value?: UserByEmailRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

